export default __webpack_public_path__ + "static/2191-3d7fba3544f948accd3a75393d519aa2.gif";